export default {
    cheatsheet: {
        title: "Scheda pronostici",
        empty: {
            noPlaysAvailable: "Nessuna giocata disponibile",
        },
        separators: {
            noLongerPerfect: "Non è più 100% sotto questo punto",
        },
        generate: {
            homeRow: "Genera la tua scheda pronostici",
            results: {
                title: "La tua cheatsheet",
                subtitle: "Generata",
            },
            actions: {
                generate: "Genera",
            },
            options: {
                all: "Tutto",
            },
            empty: {
                title: "Nessuna prop trovata",
                subtitle: "Prova a modificare le selezioni per trovare altre prop.",
                action: "Modifica selezioni",
            },
            outcome: {
                title: "Cosa stai cercando?",
                subtitle: "Scegli Over o Under.",
                over: "Over",
                under: "Under",
            },
            propType: {
                title: "Cosa preferisci?",
                subtitle: "Scegli prop giocatore o squadra.",
                player: "Prop giocatore",
                team: "Prop squadra",
            },
            lineType: {
                title: "Quali linee vuoi?",
                subtitle: "Scegli principali o alternative.",
                main: "Linee principali",
                alternate: "Linee alternative",
            },
            cheatsheetType: {
                title: "Su cosa ci basiamo?",
                subtitle: "Scegli l'intervallo da usare.",
                recentForm: "Forma recente",
                versusOpponent: "Contro avversario",
                homeAwaySplits: "Casa/trasferta",
            },
            games: {
                title: "Quali partite includere?",
                subtitle: "Includi tutte le partite o scegli quelle che vuoi.",
            },
            betTypes: {
                title: "Quali prop vuoi?",
                subtitle: "Scegli i tipi di scommessa da includere.",
            },
            operators: {
                title: "Dove dobbiamo cercare?",
                subtitle: "Scegli le quote da includere.",
            },
            loader: {
                prefix: "Analisi di",
                ready: "Scheda pronta",
                accessibilityLabel: "Generazione della tua scheda pronostici",
                values: {
                    overs: "Over...",
                    unders: "Under...",
                    mainLines: "Linee principali...",
                    alternateLines: "Linee alternative...",
                    recentForm: "Forma recente...",
                    versusOpponent: "Contro avversario...",
                    homeAwaySplits: "Casa/trasferta...",
                    todaysGames: "Partite di oggi...",
                    selectedGames: "{{count}} partita/e selezionata/e...",
                    allBetTypes: "Tutti i tipi di scommessa...",
                    oneBetType: "{{name}}...",
                    twoBetTypes: "{{first}} e {{second}}...",
                    manyBetTypes: "{{count}} tipi di scommessa...",
                    yourSportsbooks: "I tuoi sportsbook...",
                    allSportsbooks: "Tutti gli sportsbook...",
                    specificSportsbooks: "{{count}} sportsbook...",
                    building: "Creazione della tua cheatsheet...",
                },
            },
        },
    },
};
